import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, LinearProgress, Skeleton } from '@mui/material';
import { paperTradingApi, BudgetOverview as BudgetData } from '../../../services/paperTradingApi';

const BudgetOverviewWidget: React.FC = () => {
  const [budget, setBudget] = useState<BudgetData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    paperTradingApi.getBudget()
      .then(setBudget)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          <Skeleton variant="text" width={150} />
          <Skeleton variant="rectangular" height={80} sx={{ mt: 2, borderRadius: 2 }} />
        </CardContent>
      </Card>
    );
  }

  const total = budget?.total_budget_eur ?? 0;
  const allocated = budget?.allocated_eur ?? 0;
  const usedPercent = total > 0 ? (allocated / total) * 100 : 0;

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} gutterBottom>Budget</Typography>

        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="body2" color="text.secondary">Verwendet</Typography>
            <Typography variant="body2">€{allocated.toLocaleString('de-DE', { minimumFractionDigits: 2 })} / €{total.toLocaleString('de-DE', { minimumFractionDigits: 2 })}</Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={Math.min(usedPercent, 100)}
            sx={{ height: 8, borderRadius: 4 }}
          />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" color="text.secondary">Verfügbar</Typography>
            <Typography variant="body2" color="success.main" fontWeight={600}>
              €{(budget?.available_eur ?? 0).toLocaleString('de-DE', { minimumFractionDigits: 2 })}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" color="text.secondary">In Strategien</Typography>
            <Typography variant="body2">€{allocated.toLocaleString('de-DE', { minimumFractionDigits: 2 })}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="body2" color="text.secondary">Gebühren gesamt</Typography>
            <Typography variant="body2" color="warning.main">
              €{(budget?.total_fees_eur ?? 0).toLocaleString('de-DE', { minimumFractionDigits: 2 })}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default BudgetOverviewWidget;
